import React from 'react';
import { cn } from '../../utils/cn';

const Card = ({
  children,
  className = '',
  hover = true,
  padding = 'normal',
  onClick = null,
  image = null,
  ...props
}) => {
  const paddingSizes = {
    none: '',
    sm: 'p-4 md:p-6',
    md: 'p-5 md:p-8',
    normal: 'p-6 md:p-8',
    lg: 'p-8 md:p-12',
    xl: 'p-10 md:p-16',
  };

  return (
    <div
      onClick={onClick}
      className={cn(
        'bg-white shadow-refined border border-neutral-100 rounded-xl',
        'transition-all duration-200 ease-out',
        hover && 'hover:-translate-y-0.5 hover:shadow-elegant',
        onClick && 'cursor-pointer',
        paddingSizes[padding],
        className
      )}
      {...props}
    >
      {image && (
        <div className="mb-6 -mt-8 -mx-8 overflow-hidden rounded-t-xl">
          <img src={image} alt="" className="w-full h-64 object-cover" />
        </div>
      )}
      {children}
    </div>
  );
};

export default Card;

